import * as React from 'react'
import ProductCreate from '../../containers/products/ProviderProductCreate'

const ProviderProductCreatePage = (props: any) => {
  return (
    <div className='ProviderProductCreate'>
      <ProductCreate {...props} />
    </div>
  )
}

export default ProviderProductCreatePage



// WEBPACK FOOTER //
// ./src/components/products/ProviderProductCreatePage.tsx